// UTM capture: last paid click attribution for Shopify order note_attributes
(function () {
  var PAID_MEDIUMS = ['cpc', 'paid', 'ppc', 'paidsearch', 'paid search'];
  var COOKIE_NAME = 'ms4l_utm';
  var COOKIE_DAYS = 30;

  function getParam(name) {
    return new URLSearchParams(window.location.search).get(name) || '';
  }

  function setCookie(value) {
    var expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
    document.cookie = COOKIE_NAME + '=' + encodeURIComponent(JSON.stringify(value)) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function getCookie() {
    var match = document.cookie.match('(?:^|; )' + COOKIE_NAME + '=([^;]*)');
    if (!match) return null;
    try { return JSON.parse(decodeURIComponent(match[1])); } catch (e) { return null; }
  }

  function captureUTM() {
    var source = getParam('utm_source');
    var medium = getParam('utm_medium').toLowerCase();
    var campaign = getParam('utm_campaign');
    var content = getParam('utm_content');
    var term = getParam('utm_term');
    var gclid = getParam('gclid');
    var msclkid = getParam('msclkid');

    if (source && PAID_MEDIUMS.indexOf(medium) !== -1) {
      setCookie({ source: source, medium: medium, campaign: campaign, content: content, term: term });
    } else if (gclid) {
      // Google Ads auto-tagging (no UTM set manually)
      setCookie({ source: source || 'google', medium: 'cpc', campaign: campaign, content: content, term: term, gclid: gclid });
    } else if (msclkid) {
      // Microsoft/Bing Ads auto-tagging
      setCookie({ source: source || 'bing', medium: 'cpc', campaign: campaign, content: content, term: term, msclkid: msclkid });
    }
  }

  function injectCartAttributes() {
    var utm = getCookie();
    if (!utm || !utm.source) return;

    var attributes = {};
    attributes['utm_source']   = utm.source;
    attributes['utm_medium']   = utm.medium;
    attributes['utm_campaign'] = utm.campaign || '';
    if (utm.content) attributes['utm_content'] = utm.content;
    if (utm.term)    attributes['utm_term']    = utm.term;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () {});
  }

  captureUTM();
  // Inject into cart on page load (covers add-to-cart flows and cart page)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectCartAttributes);
  } else {
    injectCartAttributes();
  }
})();
